module.exports = __webpack_public_path__ + "img/114.32314a3a.png";